import { Component, Input } from '@angular/core';
import { ManipulativeType } from 'app/question/constants/manipulative-type.enum';
import { QuestionAnswerType } from 'app/question/constants/question-answer-type';
import * as questionUtils from 'app/question/utils/question-utils';
import { MissionReportQuestionResultsModel } from 'app/teacher/models/mission-report-question-results.model';
@Component({
    selector: 'kh-tq-answer-content',
    templateUrl: './tq-answer-content.component.html',
    styleUrls: ['./tq-answer-content.component.less'],
    standalone: false
})
export class TqAnswerContentComponent {
  public utils = questionUtils;

  @Input() public choice!: MissionReportQuestionResultsModel;
  @Input() public answerType!: QuestionAnswerType;
  @Input() public manipulativeType!: ManipulativeType;
  @Input() public textProperty:string = 'AnswerText';
}